import { AppLink } from '@/shared/components/AppLink';

interface StripSectionProps {
  data: Record<string, unknown> & {
    title?: string[];
    description?: string;
    btn?: string;
    link?: string;
    shouldRefresh?: boolean;
  };
  sectionKey: string;
  eventLabel?: string;
  priority?: number;
}

export default function StripSection({ 
  data, 
  sectionKey, 
  eventLabel, 
  priority 
}: StripSectionProps) {
  const title = data.title || [];
  const description = data.description || '';
  const btn = data.btn || '';
  const link = data.link || '#';

  // Title structure: title[0] + highlighted title[1] + title[2]
  const titlePart1 = title[0] || '';
  const titleHighlight = title[1] || '';
  const titlePart2 = title[2] || '';

  return (
    <section className="border-t border-b border-[#FFE5E5] md:border-none py-4 md:py-6 bg-white md:bg-transparent">
      <div className="container-fluid">
        {/* Outer wrapper with first gradient - Desktop only */}
        <div
          className="md:rounded-lg md:p-[1px] strip-outer-gradient"
        >
          {/* Inner wrapper with second gradient - Desktop only */}
          <AppLink
            to={link}
            className="flex items-center justify-center gap-4 py-2 relative block ga-event-trigger hover:opacity-90 transition-opacity strip-inner-gradient"
            data-eventname={`${sectionKey}_${titlePart1.replace(/\s/g, '')}`}
            data-pos={priority}
            data-sectionname={eventLabel}
            title={titlePart1}
            aria-label={titlePart1}
            shouldRefresh={data.shouldRefresh}
          >
            {/* Left: Title and Description */}
            <div className="md:flex md:items-center">
              {title.length > 0 && (
                <div className="text-[13px] md:text-lg font-bold text-[#032C5E] mb-1 md:mb-0">
                  <span className="whitespace-nowrap">{titlePart1} </span>
                  <strong className="text-[#D32F2F] font-bold whitespace-nowrap">{titleHighlight}</strong>
                  {titlePart2 && <span className="whitespace-nowrap"> {titlePart2}</span>}
                </div>
              )}
              {description && (
                <div className="text-[11px] md:text-sm text-[#666] leading-relaxed md:ml-2">
                  {description}
                </div>
              )}
            </div>

            {/* Right: Button */}
            {btn && (
              <div>
                <span className="inline-block bg-[#F6C2CB] text-[#032C5E] font-bold px-4 py-2 md:px-6 md:py-2 rounded-md text-sm md:text-base whitespace-nowrap pointer-events-none md:shadow-md">
                  {btn}
                </span>
              </div>
            )}
          </AppLink>
        </div>
      </div>
    </section>
  );
}

